export default {
    identCode: "",
}